import React from "react";
import QuestCardSkeleton from "./QuestCardSkeleton";
import "./Quest.css";
import "./QuestSkeleton.css";

const QuestCardsSkeleton = () => {
    return (
        <div className="">
            <div className="quest-card-title-container">
                <div className="quest-card-title-icon skeleton-pulse"></div>
                <div className="quest-card-title-skeleton skeleton-pulse"></div>
            </div>
            <div className="quest-cards-container">
                {[1, 2, 3].map((item) => (
                    <QuestCardSkeleton key={item} />
                ))}
            </div>
        </div>
    );
};

export default QuestCardsSkeleton;
